import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { trackContactClick } from "../utils/analytics";
import { getDisplayColor, getDisplayPrice } from "../utils/productDisplay";
import { getOptimizedImageUrl, getResponsiveImageSrcSet } from "../utils/imageUrl";

export default function ProductCard({ product, onClick }) {
  const productId = String(product._id || product.id || product.slug || "");
  const productHref = `/${product.slug || productId}`;

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-[#e5d9cd] bg-[#fffdf9] shadow-[0_8px_24px_rgba(88,63,45,0.08)] transition hover:-translate-y-0.5 hover:shadow-[0_14px_34px_rgba(88,63,45,0.14)]">
      <Link
        to={productHref}
        onClick={onClick}
        aria-label={`Xem chi tiết ${product.name}`}
        className="flex flex-1 flex-col outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--color-primary)]"
      >
        <div className="aspect-[4/3] w-full overflow-hidden bg-[#eee5db]">
          <img
            src={getOptimizedImageUrl(product.image, { width: 480 })}
            srcSet={getResponsiveImageSrcSet(product.image, [320, 480, 720])}
            sizes="(max-width: 639px) 50vw, (max-width: 1023px) 50vw, 33vw"
            alt={product.name}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-[center_65%] transition duration-300 group-hover:scale-[1.02]"
          />
        </div>
        <div className="flex flex-1 flex-col p-2.5 pb-0 sm:p-4 sm:pb-0">
          <h3 className="line-clamp-2 min-h-[2.5rem] text-sm font-semibold leading-5 sm:min-h-[3rem] sm:text-lg sm:leading-6">
            {product.name}
          </h3>
          <p className="mt-1 text-sm font-bold text-red-600 sm:text-base">
            {getDisplayPrice(product.price)}
          </p>
          <p className="mt-0.5 truncate text-xs text-gray-600 sm:text-sm">
            {getDisplayColor()}
          </p>
        </div>
      </Link>
      <div className="p-2.5 pt-0 sm:p-4 sm:pt-0">
        <a
          href="https://m.me/cunghome21"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => {
            trackContactClick("Messenger product card", {
              content_ids: [productId],
              content_name: product.name,
              content_type: "product",
              item_id: productId,
              item_name: product.name,
              item_category: product.type,
            });
          }}
          className="mt-2.5 flex min-h-11 w-full items-center justify-center gap-1.5 rounded-md bg-[var(--color-primary)] px-2 py-2 text-xs font-semibold text-white transition hover:bg-[#805b42] sm:mt-3 sm:gap-2 sm:px-3 sm:py-2.5 sm:text-sm"
        >
          <MessageCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
          <span className="sm:hidden">Tư vấn</span>
          <span className="hidden sm:inline">Tư vấn qua fanpage</span>
        </a>
      </div>
    </article>
  );
}
